<!--  -->
<template>
  <div class="singleSelect" v-show="show" @click.self="show = false">
    <div class="content">
      <div class="list" :class="{active:item.checked}" v-for="(item, k) in currentSelect" :key="k" @click="change(item)">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    currentSelect: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    change(data) {
      this.$emit('selectRes', data);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.singleSelect {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
  background: rgba($color: #000, $alpha: 0.5);
  .content {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: 251px;
    padding: 43px 0;
    background: #fff;
    border-radius: 36px 36px 2px 2px;
    box-shadow: 0 -4 20px 0 rgba(0, 0, 0, 0.1);
    .list {
      display: flex;
      align-items: center;
      height: 87px;
      margin-bottom: 18px;
      padding: 0 58px;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 38px;
      text-align: left;
    }
    .list.active {
      color: #ff7f41;
      background: #fff3ee;
    }
  }
}
</style>
